import { GeneralImpl } from "../data/GeneralsImpl";
import { IGeneralRepository } from "../domain/repositories/IGeneralRepository";
import { GeneralsUseCase } from "../domain/useCases/GeneralsUseCase";
import { GeneralViewModel } from "../presentation/viewModel/GeneralViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class GeneralsInjection extends InjectionModule {
  private static readonly generalRepositoryToken = Symbol("IGeneralRepository");
  private static readonly generalsUseCaseToken = Symbol("GeneralsUseCase");
  private static readonly generalViewModelToken = Symbol("GeneralViewModel");

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.generalRepositoryToken,
      useClass: GeneralImpl,
    },
    {
      scope: "otherRepo",
      token: this.generalsUseCaseToken,
      useClass: GeneralsUseCase,
    },
    {
      scope: "viewModel",
      token: this.generalViewModelToken,
      useClass: GeneralViewModel,
    },
  ];

  static getRepo() {
    return this.resolve<IGeneralRepository>(this.generalRepositoryToken);
  }

  static getUseCase() {
    return this.resolve<GeneralsUseCase>(this.generalsUseCaseToken);
  }
}
